import src from "IMAGE";
export default { src, width: 702, height: 285, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAANElEQVR42lWJOQoAQAjE/P9bvRDBcpYpXLAIIUTMDKoK2t0PVQXZiIjPdndDMvNMNuGcGTyWals/1DEKoAAAAABJRU5ErkJggg=="};
